module.exports = __webpack_public_path__ + "static/media/PRACTICA7.97b85c0d.jpg";